/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Colenddate3Inputs */

const zh_adminsubs_colenddate3 = /** @type {(inputs: Adminsubs_Colenddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结束日期`)
};

const en_adminsubs_colenddate3 = /** @type {(inputs: Adminsubs_Colenddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End Date`)
};

const es_adminsubs_colenddate3 = /** @type {(inputs: Adminsubs_Colenddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de fin`)
};

/**
* | output |
* | --- |
* | "End Date" |
*
* @param {Adminsubs_Colenddate3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_colenddate3 = /** @type {((inputs?: Adminsubs_Colenddate3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Colenddate3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_colenddate3(inputs)
	if (locale === "en") return en_adminsubs_colenddate3(inputs)
	return es_adminsubs_colenddate3(inputs)
});
export { adminsubs_colenddate3 as "adminSubs_colEndDate" }